import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../UI';

interface PropTypes {
  onClick: (e: any) => void;
  name: string;
}

const MuteModal: React.FC<PropTypes> = ({ name, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="w-3/4 p-12 m-auto text-center">
      <h2 className="font-bold text-center text-lg">
        {t('chatroom.muteModalTitle', {
          name,
        })}
      </h2>
      <p className="text-grey-50 pt-4">{t('chatroom.muteModalDesc')}</p>
      <div className="flex justify-center pt-8">
        <Button type="button" variant="primary" onClick={onClick}>
          {t('chatroom.muteModalBtn')}
        </Button>
      </div>
    </div>
  );
};

export default MuteModal;
